
export const AccountFeatures = {
    ORDER: 'ORDER',
    XPERIENCE: 'XPERIENCE',
    PRESCRIPTION: 'PRESCRIPTION',
    INVOICE: 'INVOICE',
    BEXIO: 'BEXIO',
    WAREHOUSE: 'WAREHOUSE',
    SUPPLIER_STOCK: 'SUPPLIER_STOCK',
    REPORTING: 'REPORTING'
}